import { render, staticRenderFns } from "./UserContactPage.vue?vue&type=template&id=2ca90298&scoped=true&"
import script from "./UserContactPage.vue?vue&type=script&lang=js&"
export * from "./UserContactPage.vue?vue&type=script&lang=js&"
import style0 from "./UserContactPage.vue?vue&type=style&index=0&id=2ca90298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca90298",
  null
  
)

export default component.exports